import AggregateConfig from "../../configurations/QueryBuilder/AggregateConfig.json";
import CompareConfig from "../../configurations/QueryBuilder/CompareConfig.json";
import CompareOperatorsConfig from "../../configurations/QueryBuilder/CompareOperatorsConfig.json";

const aggregateFunctionConfig = AggregateConfig.aggregateFunction;
const compareFunctions = CompareConfig.compareFunction;
const compareOperators = CompareOperatorsConfig.compareOperators;
/**
 * In cases where field is dynamic, returns new field configuration
 * @param {*} fieldConfig
 * @param {*} keywords
 * @param {*} tableHash
 * @param {*} fieldSet
 * @param {*} stageConfig
 */
const dynamicFieldEngine = (fieldConfig, keywords, tableHash, fieldSet, stageConfig) => {
	switch (stageConfig["stage-name"]) {
		case "groupBy":
			let dependentFieldOverride = null;
			var dependentKeyValue = fieldSet.find(
				field => field["field-name"] === fieldConfig["dependent-key"]
			).value;
			const aggregateFieldOverride = aggregateFunctionConfig[dependentKeyValue]
				? aggregateFunctionConfig[dependentKeyValue]["field-override"]
				: false;

			if (dependentKeyValue && fieldConfig["field-name"] === "buckets") {
				let keyword = keywords.find(elem => {
					return elem.keyword === dependentKeyValue[0];
				});

				if (
					keyword &&
					(keyword.dataType === "number" || keyword.dataType === "universal") &&
					dependentKeyValue.length === 1
				) {
					dependentFieldOverride = {
						hide: false
					};
				} else {
					dependentFieldOverride = {
						hide: true,
						value: []
					};
				}
			} else {
				dependentFieldOverride = false;
			}

			if (aggregateFieldOverride) {
				return aggregateFieldOverride;
			} else if (dependentFieldOverride) {
				return dependentFieldOverride;
			} else {
				return {};
			}
		case "addFieldParent":
			var dependentKeyValue = fieldSet.find(
				field => field["field-name"] === fieldConfig["dependent-key"]
			).value;
			var targetKeyword = keywords.find(key => key.keyword === dependentKeyValue);
			if (dependentKeyValue) {
				return {
					value:
						fieldConfig["field-name"] === "foreignTable"
							? targetKeyword.foreignTable
							: targetKeyword.foreignField
				};
			} else {
				return {};
			}
		case "addFilter":
			var dependentKeyValue = fieldSet.find(
				field => field["field-name"] === fieldConfig["dependent-key"]
			).value;

			if (dependentKeyValue) {
				let keyword = keywords.find(elem => {
					return elem.keyword === dependentKeyValue;
				});

				if (keyword && keyword.dataType) {
					if (
						keyword.dataType === "foreignKey" &&
						keyword.foreignField === "id" &&
						keyword.keyType === "FK"
					) {
						var dependentKeywordType = "profile-ref";
					} else if (keyword.dataType === "foreignKey" && keyword.foreignField !== "id") {
						var dependentKeywordType = keyword.foreignTable;
					} else {
						var dependentKeywordType = keyword.dataType;
					}
				}
			}

			var compareFieldOverride = compareFunctions[dependentKeyValue]
				? JSON.parse(JSON.stringify(compareFunctions[dependentKeyValue]))
				: false;

			var compareOperatorFieldOverride = dependentKeywordType
				? compareOperators[dependentKeywordType]
					? compareOperators[dependentKeywordType]
					: compareOperators["other"]
				: false;

			if (compareFieldOverride) {
				compareFieldOverride.value = fieldConfig["value"] || compareFieldOverride.value;
				return compareFieldOverride;
			} else if (compareOperatorFieldOverride) {
				return compareOperatorFieldOverride;
			} else {
				return {};
			}

		default:
			return {};
	}
};

export default dynamicFieldEngine;
